import { Workbook } from 'exceljs';

import {
  addDescriptionRow,
  addHeadersRows,
  addInstructionsRow,
  addKeysRow,
  configureWorksheetView,
} from './formatters/styleFormatter';
import { addValidationsToWorksheet } from './formatters/validationFormatter';
import { ExcelColumnDefinition, ExcelWorkbookOptions } from './types';

/**
 * Creates an Excel workbook with a configured worksheet based on column definitions
 *
 * @param columns Array of Excel column definitions to include in the workbook
 * @param options Configuration options for the workbook
 * @returns A configured Excel workbook
 */

const DEFAULT_SHEET_NAME = 'Sheet1';
export const createExcelWorkbook = (columns: Array<ExcelColumnDefinition>, options: ExcelWorkbookOptions): Workbook => {
  const { instructionText, freezeHeaderRows = true, maxRowCount = 99999 } = options;

  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet(options.sheetName || DEFAULT_SHEET_NAME);

  // Track the current row index
  let currentRow = 1;

  // Add instructions row if text is provided
  const instructionsRowCount = addInstructionsRow(worksheet, columns, instructionText);
  currentRow += instructionsRowCount;

  // Add hidden keys row right after instructions, before the headers
  addKeysRow(worksheet, columns, currentRow);
  currentRow += 1;

  // Add styled rows
  const numberOfHeaderRows = addHeadersRows(worksheet, columns, currentRow);
  currentRow += numberOfHeaderRows;

  addDescriptionRow(worksheet, columns, currentRow);
  currentRow += 1;

  // Configure worksheet view (freezing headers, etc.)
  configureWorksheetView(worksheet, freezeHeaderRows, currentRow);

  // Add validations - start from the first data row (after headers and descriptions)
  addValidationsToWorksheet(worksheet, columns, currentRow, maxRowCount);

  return workbook;
};
